import React from 'react';
import PropTypes from 'prop-types';
import ApplicationPage from 'site/application-page';
import Container from 'common/container';
import Link from 'common/link';

import ForgotPasswordForm from './form';

const ForgotPasswordPage = ({ onSubmit, requestPasswordReset, showFlash }) => (
    <ApplicationPage>
        <Container className="max-w-xxxl sm:py-12 py-24 flex-1 flex flex-col justify-center text-center">
            <div className="max-w-md mx-auto flex-no-shrink">
                <h1 className="text-xl font-bold text-gray-dark leading-tight">Reset Password</h1>
                <p className="text-base font-regular text-gray leading-loose mt-4">
                    After entering your email address and submitting this form, we&apos;ll send a
                    reset link to your email address.
                </p>
            </div>
            <div className="w-full mx-auto" css={{ maxWidth: 550 }}>
                <div className="sm:p-6 p-12 my-12 sm:-mx-4 bg-white shadow-md">
                    <ForgotPasswordForm
                        onSubmit={() => onSubmit('/sign-in')}
                        requestPasswordReset={({ variables }) =>
                            requestPasswordReset({ variables })
                        }
                        showFlash={showFlash}
                    />
                </div>
                <p>
                    <Link to="/sign-in" className="link-green">
                        Go back
                    </Link>
                </p>
            </div>
        </Container>
    </ApplicationPage>
);

ForgotPasswordPage.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    requestPasswordReset: PropTypes.func.isRequired,
    showFlash: PropTypes.func.isRequired,
};

export default ForgotPasswordPage;
